import script from "./RecCheckboxes.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./RecCheckboxes.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./RecCheckboxes.vue?vue&type=style&index=0&id=62440d1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62440d1c"]])

export default __exports__